<template>
  <div>
    <v-dialog v-model="model" max-width="800" persistent scrollable>
      <material-card
        :title="$t('components.claims.flags_dialog.select_flags')"
        :color="$vuetify.theme.themes.light.primary"
        icon="flag"
      >
        <v-card-text>
          <v-form v-model="valid">
            <v-row row class="flex-nowrap" align="center">
              <v-col xs12 md4>
                <v-select
                  :menu-props="{ contentClass: 'text-left' }"
                  outlined
                  hide-details
                  dense
                  v-model="selectedFlags"
                  :items="
                    options.Models.ClaimFlag.filter((o) => o.Readonly !== true)
                  "
                  :item-text="(item)=>translate2(item, 'Name')"
                  item-value="Id"
                  multiple
                  :label="$t('views.plangeneralparameters.flags')"
                  return-object
                >
                  <!-- <template v-slot:selection="{ item, index }">
                    <v-chip :color="item.Color">
                      <span>{{ translate2(item, 'Name') }}</span>
                    </v-chip>
                  </template>
                  <template v-slot:item="{ item, index }">
                    <v-chip :color="item.Color">
                      <span>{{ translate2(item, 'Name') }}</span>
                    </v-chip>
                  </template> -->
                </v-select>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn :loading="saving" text @click="$emit('close')">
            {{ $t("globals.close") }}
          </v-btn>
          <v-btn
            color="primary"
            :loading="saving"
            @click="save"
            :disabled="!valid"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ErrorHandler from "@/components/ErrorHandler";
import { translate2 } from "@/trans2";

export default {
  components: {
    ErrorHandler,
  },
  props: ["model", "items"],
  data() {
    return {
      error: null,
      saving: false,
      valid: false,
      selectedFlags: [],
    };
  },
  computed: {
    ...mapGetters("plansMembers", ["options"]),
    ...mapGetters("common", ["settings"]),
  },
  watch: {
    model: {
      handler(v) {
        if (!v) {
          this.selectedFlags = [];
        }
      },
    },
  },
  methods: {
    ...mapActions("claims", ["flagClaims"]),
    translate2(item, field) {
      return translate2(item, field);
    },
    async save() {
      try {
        this.saving = true;
        await this.flagClaims({
          payload: {
            FlagIds: this.selectedFlags.map((o) => o.Id),
            SubmissionIds: this.items,
          },
        });
        this.$emit("close", this.selectedFlags);
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
